import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import { setOption, startPlayback, setCurrentPlayer, updateHints } from '../REDUX/actions';
import { setGlobalOption, requestResetStats } from '../../HOME/REDUX/actions';
import ResetStatsIcon from '../../HOME/SVG/ResetStatsIcon';
import RadioIcon from '../../HOME/SVG/RadioIcon';
import AlternateIcon from '../../HOME/SVG/AlternateIcon';
import HintsIcon from '../COMPONENTS/HintsIcon';
import PlaybackIcon from '../../HOME/SVG/PlayIcon';
import { ALTERNATE, PLAYER1, PLAYER2 } from '../const';
import { FADE, HIDDEN, MAGENTA, CYAN } from '../../HOME/const';
import VolumeControl from '../../HOME/COMPONENTS/VolumeControl';

class Options extends Component {
  handleResetStats = e => {
    if (this.canResetStats()) {
      this.props.hideOptions();
      this.props.requestResetStats(true);
    }
  };

  canResetStats = () => {
    const { stats } = this.props;
    return stats && stats.plays > 0;
  };

  handleWhoStarts = who => e => {
    this.props.setOption({ name: 'whoStarts', value: who });

    if (!f.gameStarted(this.props) && who !== ALTERNATE && who !== this.props.currentPlayer) {
      this.props.setCurrentPlayer(who);
    }
  };

  handleToggleHints = on => e => {
    this.props.setOption({ name: 'hints', value: on });

    if (!this.props.hints) {
      const hints = f.getHints(this.props);

      if (hints.length) {
        this.props.updateHints(hints);
      }
    }
  };

  handlePlayback = () => {
    this.props.hideOptions();

    if (f.canPlayBack(this.props)) {
      this.props.startPlayback();
    }
  };

  render() {
    const { op, options } = this.props;
    const optionsVisibility = op === HIDDEN ? 'none' : 'inline';
    const whoStarts = options.whoStarts;
    const player1On = !whoStarts || whoStarts === PLAYER1;
    const player2On = whoStarts === PLAYER2;

    return (
      <div className={`options ${op === FADE ? 'fadeout' : 'fadein-fast'}`} style={{ display: optionsVisibility }}>
        <div className="options-x" onClick={this.props.hideOptions}>
          ×
        </div>
        <div className={`options-item${this.canResetStats() ? '' : ' options-item-disabled'}`} onClick={this.handleResetStats}>
          <ResetStatsIcon width="30" />
          <span>reset stats</span>
        </div>
        <div className="options-item" onClick={this.handleWhoStarts(PLAYER1)} id="player1-starts-button">
          <RadioIcon width="30" color={MAGENTA} on={player1On} />
          <span>player 1 always goes first</span>
        </div>
        <div className="options-item" onClick={this.handleWhoStarts(PLAYER2)} id="player2-starts-button">
          <RadioIcon width="30" color={CYAN} on={player2On} />
          <span>player 2 always goes first</span>
        </div>
        <div className="options-item" onClick={this.handleWhoStarts(ALTERNATE)} id="players-alternate-button">
          <AlternateIcon width="30" on={whoStarts === ALTERNATE} color1={MAGENTA} color2={CYAN} />
          <span>players alternate</span>
        </div>
        <div className="options-item" onClick={this.handleToggleHints(!this.props.options.hints)} id="hints-button">
          <HintsIcon width="30" on={options.hints} />
          <span>help me see valid triangles</span>
        </div>
        <div className={`options-item${f.canPlayBack(this.props) ? '' : ' options-item-disabled'}`} onClick={this.handlePlayback}>
          <PlaybackIcon width="30" />
          <span>play back this game</span>
        </div>
        <VolumeControl />
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { setOption, startPlayback, requestResetStats, setCurrentPlayer, updateHints, setGlobalOption }
)(Options);
